// Card JoKjdQUR — TTL cleanup del conversationId persistido.
// IMPORTANTE: este import va PRIMERO (antes de App / chatUIStore) porque
// ejecuta el cleanup como side-effect en el top-level del módulo. ESM
// evalúa imports en orden depth-first: el side-effect corre y termina
// antes de que el factory de Zustand en chatUIStore lea localStorage.
// Si la entry tiene >90d, la borramos y el factory genera un id fresco.
import './stores/conversationCleanup.init'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'
import { logger } from './lib/logger'
import { initSentry } from './lib/sentry'

// Sentry: init lo más temprano posible, antes del render, para capturar
// errores de carga y de runtime. Graceful: sin VITE_SENTRY_DSN, no init.
initSentry()

// Essential startup logs (only in dev with info level)
logger.info('App starting...', {
  mode: import.meta.env.MODE,
  isProduction: import.meta.env.PROD
});

// Apply CSP upgrade-insecure-requests ONLY in production
// In development, this causes http://localhost to be upgraded to https://localhost
// which fails with ERR_SSL_PROTOCOL_ERROR because local backend doesn't have SSL
if (import.meta.env.PROD) {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = 'upgrade-insecure-requests';
  document.head.appendChild(meta);
  logger.debug('[CSP] Applied upgrade-insecure-requests for production');
} else {
  logger.debug('[CSP] Skipping upgrade-insecure-requests in development (allows http://localhost)');
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)